import * as React from 'react';
import { AppPage } from '@@components/apppage';
import { IDefaultPageProps } from '@@data/entities';
import { States } from '@@services/services';
import { bindActionCreators, connectwith } from '@@commons';
import { AppTextLabel } from '@inwink/i18n';
import { AppShellMenuRegistration, IAppShellMenuConfig } from '@@components/appshellmenucontext';

interface ILicenseExpiredPageProps extends IDefaultPageProps {
    customer: States.ICustomerState;
}

function mapStateToProps(state: States.IAppState) {
    return {
        customer: state.customer,
        event: state.event,
        community: state.community
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

@connectwith(mapStateToProps, mapDispatchToProps)
export class LicenseExpiredPage extends React.Component<ILicenseExpiredPageProps, any> {
    menu: IAppShellMenuConfig;

    constructor(props) {
        super(props);
        
        this.menu = {
            key: "licenceexpired",
            match: props.match,
            config: null
        };

        this.state = {
        };
    }

    render() {
        return <AppPage
            featurecode="licenseexpired" title="page.licenseexpired.title" className="eventhomepage" i18n={this.props.i18n}>
            <AppShellMenuRegistration menuConfig={this.menu}>
                <AppTextLabel i18n="page.licenseexpired.description" />
            </AppShellMenuRegistration>
        </AppPage>;
    }
}
